// extracted by mini-css-extract-plugin
export default {"pageContentWrapper":"Page_pageContentWrapper__nBmdr","pageTitle":"Page_pageTitle__X7YzV","paragraph":"Page_paragraph__EJcQY","contentImage":"Page_contentImage__LqGRZ"};